import { render, staticRenderFns } from "./EditModalStockExpense.vue?vue&type=template&id=c71abe6a&scoped=true"
import script from "./EditModalStockExpense.vue?vue&type=script&lang=js"
export * from "./EditModalStockExpense.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c71abe6a",
  null
  
)

export default component.exports